<template>
  <div class="flexbox" v-if="getMostPopularOverview">
    <div style="width: 100%;"></div>
    <div
      style="display: flex; flex-direction: row; width: 100%; justify-content: space-between;"
    >
      <div class="box-container-left" id="sport">
        <div class="title">
          <h3>The most popular sport :</h3>
          <h5>Games played</h5>
        </div>
        <div class="box">
          <div v-if="getMostPopularOverview.most_popular_category">
            <span class="popTitle"
              >{{
                getMostPopularOverview.most_popular_category.category_name
              }}:</span
            >
            <span class="popCount">{{
              getMostPopularOverview.most_popular_category.count
            }}</span
            ><br />
          </div>
          <div v-else>No data found for this period</div>
        </div>
      </div>
      <div class="box-container-center" id="sport">
        <div class="title">
          <h3>The most popular zone :</h3>
          <h5>Games played</h5>
        </div>
        <div class="box">
          <div v-if="getMostPopularOverview.most_popular_field">
            <span class="popTitle"
              >{{ getMostPopularOverview.most_popular_field.field_name }}:</span
            >
            <span class="popCount">{{
              getMostPopularOverview.most_popular_field.count
            }}</span
            ><br />
          </div>
          <div v-else>No data found for this period</div>
        </div>
      </div>
      <div class="box-container-right" id="sport">
        <div class="title">
          <h3>The most popular exercise :</h3>
          <h5>Games played</h5>
        </div>
        <div class="box">
          <div v-if="getMostPopularOverview.most_popular_skill_game">
            <span class="popTitle"
              >{{
                getMostPopularOverview.most_popular_skill_game.skill_game_name
              }}:</span
            >
            <span class="popCount">{{
              getMostPopularOverview.most_popular_skill_game.count
            }}</span
            ><br />
          </div>
          <div v-else>No data found for this period</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["getMostPopularOverview"])
  }
};
</script>

<style lang="scss" scoped>
.flexbox {
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
  padding: 16px 0;
}

.box {
  padding: 27px 33px 30px 26px;
}

.box * {
  background-color: #383838;
  font-family: Montserrat-SemiBold;
}
h3 {
  margin: 40px 32px 15px 0px;
}
.popTitle {
  width: 200px;
}
.popCount {
  margin: 0 12px 0 100px;
}
.popRate1 {
  margin-left: 20px;
  color: #56e656;
}
.popRatePlus {
  color: #56e656;
}
.popRate0 {
  margin-left: 30px;
  color: #fd2d2d;
}

@media (min-width: 576px) {
  .flexbox {
    flex-flow: row wrap;
  }
  .flexbox > .box-container-left {
    order: 1;
    flex-grow: 1;
  }
  .flexbox > .box-container-right {
    order: 2;
    flex-grow: 1;
  }
  .flexbox > .box-container-center {
    order: 3;
    flex-grow: 1;
  }
}
</style>
